type SearchState = {
  editorialContentItems: [],
  editorialContentCount: Number | undefined,
  dataserviceItems: [],
  dataserviceCount: Number | undefined,
  datasetseriesItems: [],
  datasetseriesCount: Number | undefined,
  combinedItems: [],
  totalCount: Number | undefined,
  searchFacets: [],
  datasetsWithLikes: [],
  sortType: string,
  mostLikedTotal: number,
  isMostLikedMode: boolean,
  mostLikedPage: number,
  sortTriggerId: number,
  showFilter: boolean
};

const state: SearchState = {
  editorialContentItems: [],
  editorialContentCount: undefined,
  dataserviceItems: [],
  dataserviceCount: undefined,
  datasetseriesItems: [],
  datasetseriesCount: undefined,
  combinedItems: [],
  totalCount: undefined,
  searchFacets: [],
  datasetsWithLikes: [],
  sortType: '',
  mostLikedTotal: 0,
  isMostLikedMode: false,
  mostLikedPage: 1,
  sortTriggerId: 0,
  showFilter: true
};

const getters = {
  getEditorialContentItems: (state: SearchState) => state.editorialContentItems,
  getEditorialContentCount: (state: SearchState) => state.editorialContentCount,
  getDataserviceItems: (state: SearchState) => state.dataserviceItems,
  getDataserviceCount: (state: SearchState) => state.dataserviceCount,
  getDatasetseriesItems: (state: SearchState) => state.datasetseriesItems,
  getDatasetseriesCount: (state: SearchState) => state.datasetseriesCount,
  getCombinedItems: (state: SearchState) => state.combinedItems,
  getTotalCount: (state: SearchState) => state.totalCount,
  getSearchFacets: (state: SearchState) => state.searchFacets,
  getLikedDatasets: (state: SearchState) => state.datasetsWithLikes || [],
  getSortType: (state: SearchState) => state.sortType,
  getMostLikedTotal: (state: SearchState) => state.mostLikedTotal,
  getMostLikedPage: (state: SearchState) => state.mostLikedPage,
  getIsMostLikedMode: (state: SearchState) => state.isMostLikedMode,
  getSortTriggerId: (state: SearchState) => state.sortTriggerId,
  getShowFilter: (state: SearchState) => state.showFilter
};

const actions = {
  setEditorialContentItems({ commit }, datasets) {
    commit('SET_EDITORIAL_CONTENT_ITEMS', datasets);
  },
  setEditorialContentCount({ commit }, count) {
    commit('SET_EDITORIAL_CONTENT_COUNT', count);
  },
  setDataserviceItems({ commit }, datasets) {
    commit('SET_DATA_SERVICE_ITEMS', datasets);
  },
  setDataserviceCount({ commit }, count) {
    commit('SET_DATA_SERVICE_COUNT', count);
  },
  setDatasetseriesItems({ commit }, datasets) {
    commit('SET_DATA_SERIES_ITEMS', datasets);
  },
  setDatasetseriesCount({ commit }, count) {
    commit('SET_DATA_SERIES_COUNT', count);
  },
  setCombinedItems({ commit }, datasets) {
    commit('SET_COMBINED_ITEMS', datasets);
  },
  setTotalCount({ commit }, count) {
    commit('SET_TOTAL_COUNT', count);
  },
  setSearchFacets({ commit }, searchFacets) {
    commit('SET_SEARCH_FACETS', searchFacets);
  },
  setLikedDatasets({ commit }, datasets) {
    commit('SET_DATASETS', datasets);
  },
  setSortType({ commit }, sortType) {
    commit('SET_SORT_TYPE', sortType);
  },
  setMostLikedAll({ commit }, list) {
    commit('SET_MOST_LIKED_ALL', list);
  },
  setMostLikedPage({ commit }, page) {
    commit('SET_MOST_LIKED_PAGE', page);
  },
  setIsMostLikedMode({ commit }, value) {
    commit('SET_IS_MOST_LIKED_MODE', value);
  },
  toggleShowFilter({ commit, state }) {
    commit('SET_SHOW_FILTER', !state.showFilter);
  }
};

const mutations = {
  SET_EDITORIAL_CONTENT_ITEMS(state: SearchState, data) {
    state.editorialContentItems = data;
  },
  SET_EDITORIAL_CONTENT_COUNT(state: SearchState, count) {
    state.editorialContentCount = count;
  },
  SET_DATA_SERVICE_ITEMS(state: SearchState, data) {
    state.dataserviceItems = data;
  },
  SET_DATA_SERVICE_COUNT(state: SearchState, count) {
    state.dataserviceCount = count;
  },
  SET_DATA_SERIES_ITEMS(state: SearchState, data) {
    state.datasetseriesItems = data;
  },
  SET_DATA_SERIES_COUNT(state: SearchState, count) {
    state.datasetseriesCount = count;
  },
  SET_COMBINED_ITEMS(state: SearchState, data) {
    state.combinedItems = data;
  },
  SET_TOTAL_COUNT(state: SearchState, count) {
    state.totalCount = count;
  },
  SET_SEARCH_FACETS(state: SearchState, searchFacets) {
    state.searchFacets = searchFacets;
  },
  SET_DATASETS(state: SearchState, datasets) {
    state.datasetsWithLikes = datasets;
  },
  SET_SORT_TYPE(state: SearchState, sortType: string) {
    state.sortType = sortType;
  },
  SET_MOST_LIKED_ALL(state: SearchState, data) {
    state.mostLikedTotal = Array.isArray(data) ? data.length : 0;
  },
  SET_IS_MOST_LIKED_MODE(state: SearchState, value: boolean) {
    state.isMostLikedMode = value;
  },
  SET_MOST_LIKED_PAGE(state: SearchState, page: number) {
    state.mostLikedPage = page;
  },
  TRIGGER_SORT_RELOAD(state) {
    state.sortTriggerId = Date.now();
  },
  SET_SHOW_FILTER(state: SearchState, value: boolean) {
    state.showFilter = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
